var base = require('auth/register-stripe');

Vue.component('spark-register-stripe', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/auth/register-stripe.js